/** Per-question working state for the AskUserPrompt stepper — kept so Back can restore a prior selection. */
export interface StepState {
  selectedLabels: string[]
  otherText: string
}

export function emptyStepState(): StepState {
  return { selectedLabels: [], otherText: '' }
}

/**
 * Single-select: the one chosen label, or the typed Other text if that's what was submitted.
 * MultiSelect: selected labels in option order joined with ", ", with a non-empty Other
 * appended last.
 */
export function computeStepAnswer(step: StepState): string {
  const other = step.otherText.trim()
  if (step.selectedLabels.length > 0) {
    return other ? [...step.selectedLabels, other].join(', ') : step.selectedLabels.join(', ')
  }
  return other
}
